/* eslint-disable */
import { HERO_PROPS, INDUSTRY_DEMOS_PROPS } from '@/components/_rebrand/_pages/ProductTour/ProductTour.props';
import Header from '@/components/_rebrand/Header';
import { ProductTourHero } from '@/components/_rebrand/ProductTourHero';
import ProductTourIndustryDemos from '@/components/_rebrand/ProductTourIndustryDemos';
import ProductTourFooter from '@/components/pages/product-tour/ProductTourFooter';
import HEADER_PROPS from '@/constants/global-props/header';
import { ProductTourPageQuery } from '@/graphql';
import ProductTourPageQueryDocument from '@/graphql/queries/ProductTourPage.gql';
import { getStaticPageProps } from '@/lib/next';
import MasterTemplate from '@/templates/MasterTemplate';

export interface ProductTourPageProps extends ProductTourPageQuery { }

const ProductTourPage: PageTemplate<ProductTourPageProps> = ({ entry }) => {

  return (
    <>
      <ProductTourHero
        {...HERO_PROPS}
      />
      <ProductTourIndustryDemos {...INDUSTRY_DEMOS_PROPS} />
      <ProductTourFooter props={entry?.footer} />
    </>
  );
};

export default ProductTourPage;

ProductTourPage.template = (props) => <MasterTemplate navigation={<Header {...HEADER_PROPS} invert={true} />} className='mt-0' {...props} />;

export const getStaticProps = getStaticPageProps('product-tour', async ({ client }) => {
  const props = await client.request<ProductTourPageQuery>(ProductTourPageQueryDocument);
  return {
    props,
  };
});
